const OrgLayout = ({ children, header }) => {
  return (
    <div className="grid grid-rows-[60px_1fr] w-screen bg-gray-100">
      {header}

      <main className="p-5 w-full h-[calc(100vh-60px)] overflow-y-scroll">{children}</main>
    </div>
  )
}

export default OrgLayout
